import { useState, useEffect, useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // for selectable events
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import EventDetailModal from './Calendar/EventDetailModal';
import EventCreateModal from './Calendar/EventCreateModal';
import EventRescheduleModal from './Calendar/EventRescheduleModal';
import EventCompleteModal from './Calendar/EventCompleteModal';
import EventCancelModal from './Calendar/EventCancelModal';
import Swal from 'sweetalert2';
import axios from 'axios';
import { env } from '../../env';

const CalendarComponent = ({ viewType, appointmentList, customerId, appointmentCustomerInfo, sendViewTypeFromChild, updateCustomerData }) => {
    const { t } = useTranslation();
    const [calendarHeight, setCalendarHeight] = useState(window.innerHeight - 120);
    const [events, setEvents] = useState([]);
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showCompleteViewModal, setShowCompleteViewModal] = useState(false);
    const [showRescheduleViewModal, setShowRescheduleViewModal] = useState(false);
    const [showCancelViewModal, setShowCancelViewModal] = useState(false);

    const [eventDetails, setEventDetails] = useState({});
    const [localViewType, setLocalViewType] = useState(viewType);
    const [currentDate, setCurrentDate] = useState('');
    const calendarRef = useRef(null);
    const [detailView, setDetailView] = useState('large');
    const [showCreateValue, setShowCreateValue] = useState(false);
    const [customer, setCustomer] = useState(0);
    const [appointmentTypeList, setAppointmentTypeList] = useState([]);
    const [kindOfAppointmentList, setKindOfAppointmentList] = useState([]);

    useEffect(() => {
        const updateHeight = () => {
            setCalendarHeight(window.innerWidth < 640 ? window.innerHeight - 100 : window.innerHeight - 80);
            if(window.innerWidth < 376) {
                setDetailView('small')
            }
        };
        window.addEventListener('resize', updateHeight);
        updateHeight();
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    useEffect(() => {
        setEvents(appointmentList);

        if (viewType !== localViewType) {
            setLocalViewType(viewType);
        }
    }, [viewType, appointmentList]);

    useEffect(() => {
        if (calendarRef.current) {
            calendarRef.current.getApi().changeView(localViewType);
        }
    }, [localViewType]);

    useEffect(() => {
        setCustomer(customerId);
        if ((customerId > 0) && calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            const now = moment();
            const startStr = now.format('YYYY-MM-DDTHH:mm:ss');
            const endStr = now.clone().add(30, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
            calendarApi.select({ start: startStr, end: endStr });
        }
    }, [customerId]);

    useEffect(() => {
        const fetchData = async () => {
            await getAppointmentTypeList(baseUrl, token);
            await getKindOfAppointmentList(baseUrl, token);
        };
        fetchData();
    }, [baseUrl, token]);

    const getAppointmentTypeList = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/ClientAppointments/GetAppointmentTypeList`,{ headers })
        .then((response) => {
            setAppointmentTypeList(response.data);
        }).catch((error) => {
            console.log(error);
            // if(error.response && (error.response.status === 401 || error.response.status === 404)) {
            //     localStorage.removeItem("token");
            //     localStorage.removeItem("userInfo");
            //     window.location.reload();
            // }
        });
    };
    const getKindOfAppointmentList = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/ClientAppointments/GetKindOfAppointmentList`,{ headers })
        .then((response) => {
            setKindOfAppointmentList(response.data);
        }).catch((error) => {
            console.log(error);
            // if(error.response && (error.response.status === 401 || error.response.status === 404)) {
            //     localStorage.removeItem("token");
            //     localStorage.removeItem("userInfo");
            //     window.location.reload();
            // }
        });
    };
    const handleEventClick = (info) => {
        const selectedEvent = events.find(event => event.id == info.event.id);
        setEventDetails(selectedEvent);
        setShowViewModal(!showViewModal);
    };
    const handleDateSelectFirst = (selectInfo) => {
        setShowCreateValue(true);
        setEventDetails({
            start: selectInfo.startStr,
            end: selectInfo.endStr,
            title: '',
            description: ''
        });
        if(customerId === 0) {
            setShowCreateValue(false);
            Swal.fire({
                position: "top-end",
                icon: "warning",
                title: "select customer to create appointment",
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                    title: "swal-title-small"
                }
            });
        }
    };
    const handleDateSelectSecond = (selectInfo) => {
        setEventDetails({
            start: selectInfo.startStr,
            end: selectInfo.endStr,
            title: '',
            description: ''
        });
        if(customerId === 0) {
            Swal.fire({
                position: "top-end",
                icon: "warning",
                title: "select customer to create appointment",
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                    title: "swal-title-small"
                }
            });
        } else {
            setShowCreateModal(!showCreateModal);
        }
        setShowCreateValue(false);
    };
    const handleViewToggle = (view) => {
        setLocalViewType(view);
        sendViewTypeFromChild(view);
        if (calendarRef.current) {
            calendarRef.current.getApi().changeView(view);
        }
    };
    const goToToday = () => {
        if (calendarRef.current) {
            calendarRef.current.getApi().today();
        }
    };
    const goToPrev = () => {
        if (calendarRef.current) {
            calendarRef.current.getApi().prev();
        }
    };
    const goToNext = () => {
        if (calendarRef.current) {
            calendarRef.current.getApi().next();
        }
    };
    const updateTitle = (arg) => {
        const currentMonth = arg.view.title;
        setCurrentDate(currentMonth);
    };
    const handleShowCreateModal = () => {
        setShowCreateModal(false);
        setShowCreateValue(false);
        updateCustomerData(0);
    };
    const handleModalData = (value) => {
        setEventDetails(value.data);
        setShowViewModal(false);
        if(value.type === 'complete') {
            setShowCompleteViewModal(true);
        } else if (value.type === 'reschedule') {
            setShowRescheduleViewModal(true);
        } else if (value.type === 'copy') {
            setShowCreateModal(true);
        } else if (value.type === 'cancel') {
            setShowCancelViewModal(true);
        }
        
    };
    const handleSaveEvent = () => {
        setEvents((prevEvents) => [
            ...prevEvents,
            { 
                title: eventDetails.title, 
                start: eventDetails.start, 
                description: eventDetails.description,
                status: eventDetails.status, 
                borderColor: eventDetails.borderColor,
                backgroundColor: eventDetails.backgroundColor
            }
        ]);
    };
    const handleDeleteEvent = () => {
        setEvents((prevEvents) => prevEvents.filter((event) => event.id !== eventDetails.id));
    };


    return (
        <div className='px-2 py-2 bg-white rounded-xl relative'>
            <div className="px-2 sm:px-0 flex justify-between items-center mb-4">
                <div className="flex space-x-2">
                    <button onClick={goToPrev} className="sm:px-4 sm:py-2 sm:border sm:border-background-normal sm:rounded-lg">
                        <img src="../../assets/icons/table/left-arrow-active.svg" alt='arrow' />
                    </button>
                    <button onClick={goToNext} className="hidden sm:block px-4 py-2 border border-background-normal rounded-lg">
                        <img src="../../assets/icons/table/right-arrow-active.svg" alt='arrow' />
                    </button>
                    <button onClick={goToToday} className="hidden sm:block px-4 py-2 border border-background-normal rounded-lg text-light-400 capitalize">
                        { t('today') }
                    </button>
                </div>
                <div className="text-sm sm:text-xl font-bold text-blue-normal bg-blue-light rounded-xl py-2 px-6">{currentDate}</div>
                <div className="flex space-x-2">
                    <div className='hidden sm:block'>
                        <button onClick={() => setDetailView('large')} className={(detailView === 'large' ? 'bg-gray-dark3' : 'bg-white') + " px-4 py-3 border border-background-normal rounded-l-lg"}>
                            <img className='w-5 h-5' src="../../assets/icons/profile/calendar/week.svg" alt='week' />
                        </button>
                        <button onClick={() => setDetailView('small')} className={(detailView === 'small' ? 'bg-gray-dark3' : 'bg-white') + " px-4 py-3 border-r border-y border-background-normal rounded-r-lg"}>
                            <img className='w-5 h-5' src="../../assets/icons/profile/calendar/day.svg" alt='day' />
                        </button>
                    </div>
                    <button onClick={() => handleViewToggle('dayGridMonth')} className={(viewType === 'dayGridMonth' ? 'bg-gray-dark3' : 'bg-white') + " sm:px-3 sm:py-2 sm:border sm:border-background-normal sm:rounded-lg"}>
                        <img src="../../assets/icons/profile/calendar/calendar.svg" alt='calendar' />
                    </button>
                </div>
                <button onClick={goToNext} className="block sm:hidden">
                    <img src="../../assets/icons/table/right-arrow-active.svg" alt='arrow' />
                </button>
            </div>
            <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView={localViewType}
                events={events}
                eventClick={handleEventClick}
                selectable={true}
                select={(showCreateValue && customerId !== 0) ? handleDateSelectSecond : handleDateSelectFirst}
                headerToolbar={false}
                datesSet={updateTitle}
                views={{
                    '5Day': {
                        type: 'timeGrid',
                        duration: { days: 5 },
                        buttonText: '5 Days'
                    }
                }}
                eventContent={(eventInfo) => {
                    const { title, start, end, borderColor, backgroundColor } = eventInfo.event;
                    const diffInMilliseconds = moment(end).diff(moment(start));
                    const duration = moment.duration(diffInMilliseconds);
                    const getFirstLetters = (str) => {
                        return str.split(' ')
                                .filter(word => word.length > 0)
                                .map(word => word.charAt(0).toUpperCase())
                                .join('');
                    };
                    return (
                        <div className={(detailView === 'large') 
                            ? `border-l-4 ${borderColor} ${backgroundColor} p-2 rounded text-xs text-black h-full cursor-pointer` 
                            : `border-l-4 ${borderColor} ${backgroundColor} p-2 w-12 rounded-full text-xs text-black cursor-pointer`}>
                            <div>{(detailView === 'large') ? title : getFirstLetters(title)}</div>
                            {(detailView === 'large') ? 
                                <div className="text-[10px] border border-white bg-white rounded-md p-0.5 mt-1">
                                    {moment(start).format('LT')} - {moment(end).format('LT')}
                                </div>
                                :
                                <div>
                                    {duration.minutes()}m
                                </div>
                            }
                        </div>
                    );
                }}
                eventClassNames={() => ['bg-white border-none h-auto']}
                height={calendarHeight}
            />
            {showViewModal && (
                <EventDetailModal
                    eventDetails={eventDetails}
                    setShowViewModal={setShowViewModal}
                    sendModalData={handleModalData}
                />
            )}
            {(showCreateModal && appointmentCustomerInfo && eventDetails) && (
                <EventCreateModal
                    eventDetails={eventDetails}
                    sendShowCreateModal={handleShowCreateModal}
                    customerData={appointmentCustomerInfo}
                    kindOfAppointmentList={kindOfAppointmentList}
                    appointmentTypeList={appointmentTypeList}
                />
            )}
            {showCompleteViewModal && (
                <EventCompleteModal
                    eventDetails={eventDetails}
                    setShowCompleteViewModal={setShowCompleteViewModal}
                />
            )}
            {showRescheduleViewModal && (
                <EventRescheduleModal
                    eventDetails={eventDetails}
                    setShowRescheduleViewModal={setShowRescheduleViewModal}
                />
            )}
            {showCancelViewModal && (
                <EventCancelModal
                    eventDetails={eventDetails}
                    setShowCancelViewModal={setShowCancelViewModal}
                />
            )}
        </div>
    );
};

export default CalendarComponent;
